import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
    Card,
    CardBody,
    Modal,
    ModalBody,
    Input,
    ModalHeader,
    Button,
    Row,
    Col,
    Label,
    FormFeedback,
    FormGroup,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import CuttingRequirementTable from "./CuttingRequirementTable"
import { dateFormat, dateTimeFormat, formatDateToISO } from "pages/Common"
import CreateUpdateCuttingRequirementModel from "./CreateUpdateCuttingRequirementModel"
import ErrorModel from "common/errorModel/errorModel"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import Dropzone from "react-dropzone"
import uploadImage from "../../assets/images/uploadImage.png"
import Compressor from "compressorjs"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}


function CuttingRequirementList() {
    document.title = `Requirements | Raja Rani Couture`
    let { pathname } = useLocation()
    let { state } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    // useStates
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [purchaseDoneModal, setPurchaseDoneModal] = useState(false)
    const [tableData, setTableData] = useState([]);
    const [tableDataInputFabric, setTableDataInputFabric] = useState(
        Array.from({ length: 10 }, () => ({
            Image: '',
            OrderNo: "",
            Name: "",
            DesignerBy: 0,
            Date: new Date(),
            Stuff: "",
        }))
    );
    const [fabricInputData, setFabricInputData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isEdit, setIsEdit] = useState(false)
    const [isCreate, setIsCreate] = useState(false)
    const [userData, setUserData] = useState([])
    const [editData, setEditData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(state == null ? true : false)
    const [isOrderComplete, setIsOrderComplete] = useState(false)
    const [isPurchaseComplete, setIsPurchaseComplete] = useState(false)
    const [TaskTitleTypes, setTaskTitleTypes] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
    )
    const [cost, setCost] = useState('')
    const [IsCostError, setIsCostError] = useState(false)
    const [fabricId, setFabricId] = useState(0)
    const [image, setImage] = useState('')
    const [srNo, setSrNo] = useState('')
    const [imageViewModal, setImageViewModal] = useState(false)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                setUserData(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    // filter data for fabric
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // fabric list api
    const CuttingRequirementListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("CuttingRequirement/list", {
            UserId: parseInt(userFilter),
            isOrderComplete: isOrderComplete,
            IsCuttingComplete: isPurchaseComplete,
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data?.CuttingRequirementList)
                setTotalRecords(data?.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // fabric list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            CuttingRequirementListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateDisble, dateFilter, isOrderComplete, isPurchaseComplete])

    // Create fabric handler
    const handleFabricClick = () => {
        toggle()
        setIsEdit(false)
        setIsCreate(true)
        setEditData('')
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // if (!modal) {
        //     setIsEdit(false)
        // }
    }

    const purchaseDoneToggle = () => {
        setPurchaseDoneModal(!purchaseDoneModal)
        setCost('')
    }

    const handleEdit = (data) => {
        setEditData(data)
        setIsEdit(true)
        setIsCreate(false)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this requirement permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`CuttingRequirement/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Requirement deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Requirement",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    const MarkDoneCuttingOrder = (Id, IsOrderDone) => {
        setformSumitLoading(true)
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to mark this requirement done permanently? ",
            isMobile,
        }).then(response => {
            if (response == true) {
                postApi("CuttingRequirement/mark-as-done", {
                    Id: Id,
                    IsOrderDone: IsOrderDone,
                    Cost: parseFloat(cost || 0)
                }).then(
                    ({ data, status }) => {
                        if (status === 200) {
                            setformSumitLoading(false)
                            CuttingRequirementListApi()
                            toast.success("Requirement done successfully", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            setformSumitLoading(false)
                            ErrorModel.errormodel({
                                title: "Verify Requirement",
                                text: data,
                            })
                        }
                        setIsLoading(false)
                    }
                )
            } else {
                setIsLoading(false)
            }
        })
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleMarkDone = (Id, IsOrderDone) => {
        setIsLoading(true)
        setFabricId(Id)
        MarkDoneCuttingOrder(Id, IsOrderDone)
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Image",
                accessor: "Image",
                width: "10%",
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        {row.original?.Image ? (
                            <img
                                onClick={() => handleImageView(row.original.Image, row.original.OrderNo)}
                                src={row.original.Image}
                                alt="Requirement"
                                style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "6px" }}
                            />
                        ) : (
                            <span>N/A</span>
                        )}
                    </div>
                ),
            },
            {
                Header: "Cutting Details",
                accessor: "CategoryIdsName",
                width: "10%"
            },
            {
                Header: "Qty",
                accessor: "Qty",
                width: "5%"
            },
            {
                Header: "Created By",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedByName}
                    </p>
                ),
            },
            {
                Header: "Required Date",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Required Date
                    </div>
                ),
                accessor: "RequiredDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.RequiredDate
                            ? dateFormat(row?.original?.RequiredDate?.split("T")[0], "dd-MM-yyyy")
                            : "N/A"}
                    </p>
                ),
            },
            {
                Header: "Cut By",
                accessor: "CutByName",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CutByName || "N/A"}
                    </p>
                ),
            },
            {
                Header: "Cutting Date",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Cutting Date
                    </div>
                ),
                accessor: "CuttingDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {(row.original.CuttingDate)
                            ?
                            dateFormat(row?.original?.CuttingDate?.split("T")[0], "dd-MM-yyyy")
                            : (TaskTitleTypes?.includes("20") || TaskTitleTypes?.includes("21")) ?
                                <>
                                    <div className="text-center">
                                        <Button
                                            color="primary"
                                            fabric="primary"
                                            className="btn btn-primary btn-sm "
                                            onClick={() => handleMarkDone(row.original.Id, false)}
                                        >
                                            Mark as Done
                                        </Button>
                                    </div>
                                </>
                                :
                                "N/A"}
                    </p >
                ),
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row?.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {TaskTitleTypes?.includes("20") ?
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        onClick={() => handleEdit(row.original)}
                                        id={`edittooltip${row.original.Id}`}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                                :
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        id={`edittooltip${row.original.Id}`}
                                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                            }
                            {(TaskTitleTypes?.includes("20") || TaskTitleTypes == 'null') ?
                                <li className="mytooltip">
                                    <i
                                        className="fs-6 fas fa-trash-alt btn-delete"
                                        id={`deletetooltip${row.original.Id}`}
                                        onClick={() => handleDelete(row.original.Id)}
                                    ></i>
                                    <span className="mytext">Delete</span>
                                </li>
                                :
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-trash-alt btn-delete"
                                        id={`deletetooltip${row.original.Id}`}
                                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                                    ></i>
                                    <span className="mytext">Delete</span>
                                </li>
                            }

                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Cutting Details", "Qty", "Created By", "Required Date", "Cut By", "Cutting Date", "Created On"];
            const mainTitle = "Cutting Requirements";
            const widthObj = [{
                Key: "A",
                Value: 12,
            },
            {
                Key: "B",
                Value: 20,
            },
            {
                Key: "C",
                Value: 15,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 15,
            },
            {
                Key: "F",
                Value: 12,
            },
            {
                Key: "G",
                Value: 20,
            },
            {
                Key: "H",
                Value: 15,
            },
            {
                Key: "I",
                Value: 15,
            },
            {
                Key: "J",
                Value: 18,
            },
            {
                Key: "K",
                Value: 20,
            },
            {
                Key: "L",
                Value: 15,
            },
            {
                Key: "M",
                Value: 15,
            },
            ]
            const extention = "Cutting_Requirements.xlsx"
            let excelSheetData = []

            postApi("CuttingRequirement/list", {
                UserId: parseInt(userFilter),
                IsCuttingComplete: isPurchaseComplete,
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.CuttingRequirementList.length; index++) {
                        let dataObj = {
                            CategoryIdsName: data?.CuttingRequirementList[index].CategoryIdsName || "N/A",
                            Qty: data?.CuttingRequirementList[index].Qty || "N/A",
                            CreatedByName: data?.CuttingRequirementList[index].CreatedByName || "N/A",
                            RequiredDate: data?.CuttingRequirementList[index].RequiredDate == "" || data?.CuttingRequirementList[index].RequiredDate == null
                                ? "N/A"
                                : dateTimeFormat(data?.CuttingRequirementList[index].RequiredDate, "dd-MM-yyyy"),
                            CuttingDate: data?.CuttingRequirementList[index].CuttingDate == "" || data?.CuttingRequirementList[index].CuttingDate == null
                                ? "N/A"
                                : dateTimeFormat(data?.CuttingRequirementList[index].CuttingDate, "dd-MM-yyyy"),
                            CutByName: data?.CuttingRequirementList[index].CutByName || "N/A",
                            CreatedOn: data?.CuttingRequirementList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.CuttingRequirementList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    const handleImageView = (Image, SrNo) => {
        setImage(Image)
        setSrNo(SrNo)
        imageViewToggle()
    }

    const imageViewToggle = () => {
        setImageViewModal(!imageViewModal)
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <CuttingRequirementTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isCuttingRequirementList={true}
                            handleFabricClick={handleFabricClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            writeDataToExcel={writeDataToExcel}
                            isPurchaseComplete={isPurchaseComplete}
                            setIsPurchaseComplete={setIsPurchaseComplete}
                            isOrderComplete={isOrderComplete}
                            setIsOrderComplete={setIsOrderComplete}
                            TaskTitleTypes={TaskTitleTypes}
                        />

                        {(isCreate || isEdit) &&
                            <CreateUpdateCuttingRequirementModel
                                modal={modal}
                                toggle={toggle}
                                isEdit={isEdit}
                                editData={isEdit ? editData : ''}
                                CuttingRequirementListApi={CuttingRequirementListApi}
                                AssignByData={''}
                                userData={userData}
                            />
                        }

                        <Modal
                            isOpen={purchaseDoneModal}
                            toggle={purchaseDoneToggle}
                            centered={true}
                            size="sm"
                        // style={{ width: !isMobile ? "1400px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={purchaseDoneToggle} >
                                    {"Purchase Done"}
                                </ModalHeader>
                                <ModalBody>
                                    <Row>
                                        <FormGroup className="mb-2">
                                            <Label className="form-label required">Cost</Label>
                                            <Input
                                                name="cost"
                                                className="form-control-sm"
                                                type="text"
                                                placeholder="Cost"
                                                value={cost}
                                                onKeyPress={handleKeyPress}
                                                onChange={(e) => setCost(e.target.value, setIsCostError(false))}
                                                invalid={IsCostError}
                                            />
                                            {IsCostError ? (
                                                <FormFeedback type="invalid">Cost is reuired</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Row>
                                    <Row>
                                        <Col style={{ display: "flex", justifyContent: "end" }} md={12}>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    fabric="primary"
                                                    className="btn btn-primary btn-sm "
                                                    // type="submit"
                                                    onClick={() => MarkDoneCuttingOrder(fabricId, false)}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </ModalBody>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={imageViewModal}
                            toggle={imageViewToggle}
                            centered={true}
                            size="defualt"
                            style={{ width: isMobile ? "" : "500px" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={imageViewToggle} tag="h5">
                                    Image
                                </ModalHeader>
                                <ModalBody>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <img
                                            style={{
                                                cursor: "pointer",
                                                border: "1px solid #ced4da",
                                                borderRadius: "3px",
                                            }}
                                            width="500px"
                                            height="550px"
                                            src={image}
                                        />
                                    </div>
                                </ModalBody>
                            </div>
                        </Modal >

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
CuttingRequirementList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default CuttingRequirementList
